import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import type { Child } from '@aba-denver/core';
import { useData } from '../contexts/DataContext';
import { Badge } from '../components/ui/Badge';
import { Spinner } from '../components/ui/Spinner';
import { patientAgeLabel, esdmStatus, formatDate } from '../lib/format';

export function Relatorios() {
  const { children, loading, getChildEsdmProgress } = useData();
  const navigate = useNavigate();
  const [search, setSearch] = useState('');

  const list = useMemo(() => {
    const term = search.trim().toLowerCase();
    return children
      .filter((c) => c.name.toLowerCase().includes(term))
      .sort((a, b) => a.name.localeCompare(b.name));
  }, [children, search]);

  const renderRow = (child: Child) => {
    const progressDoc = getChildEsdmProgress(child.id);
    const status = esdmStatus(progressDoc);
    return (
      <tr
        key={child.id}
        style={{ cursor: 'pointer' }}
        onClick={() => navigate(`/relatorios/${child.id}`)}
      >
        <td style={{ fontWeight: 600 }}>{child.name}</td>
        <td>{patientAgeLabel(child)}</td>
        <td>
          <Badge variant={status.variant}>{status.label}</Badge>
          {progressDoc && (
            <span className="muted" style={{ marginLeft: 8, fontSize: 13 }}>
              {formatDate(progressDoc.updatedAt)}
            </span>
          )}
        </td>
        <td style={{ textAlign: 'right' }}>
          <span className="muted">›</span>
        </td>
      </tr>
    );
  };

  return (
    <div>
      <div className="page-header">
        <div>
          <h1>Relatórios</h1>
          <p className="muted" style={{ margin: 0 }}>
            Consolidado ESDM por paciente.
          </p>
        </div>
      </div>

      <div className="card">
        <div className="row" style={{ gap: 12, marginBottom: 16, alignItems: 'center' }}>
          <input
            type="text"
            placeholder="Buscar por nome…"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{
              flex: 1,
              padding: '10px 12px',
              border: '1px solid var(--border)',
              borderRadius: 'var(--radius-sm)',
            }}
          />
        </div>

        {loading ? (
          <div style={{ padding: 24, display: 'flex', justifyContent: 'center' }}>
            <Spinner />
          </div>
        ) : list.length === 0 ? (
          <div className="empty-state">
            {children.length === 0 ? 'Nenhum paciente cadastrado ainda.' : 'Nenhum paciente encontrado.'}
          </div>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table className="table">
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>Idade</th>
                  <th>Checklist ESDM</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>{list.map(renderRow)}</tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
